const featureFlagReducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_CREATOR_FF':
      return { ...state, creatorAcademy: action.payload };

    default:
      return state;
  }
};

export default featureFlagReducer;
